import React from 'react';
import { Link } from 'react-router-dom';
import { Palmtree } from 'lucide-react';
import Seo from '@/components/Seo';
import { WhatsAppButton, CallButton } from '@/components/CTAButtons';

const NotFound = () => (
  <>
    <Seo title="Page Not Found | Provident Palm Vista Shilphata" description="The page you are looking for does not exist. Explore Provident Palm Vista Shilphata — 1, 2 & 2.5 BHK homes on Kalyan-Shilphata Road." path="/404" />
    <section className="pt-36 pb-28 bg-ivory min-h-[80vh] flex items-center">
      <div className="max-w-2xl mx-auto px-4 text-center">
        <Palmtree className="h-12 w-12 text-gold mx-auto" strokeWidth={1.25} />
        <h1 className="font-display text-6xl sm:text-7xl font-medium text-palm mt-6">404</h1>
        <p className="font-display text-2xl text-palm/70 italic mt-2">This path leads into the palms…</p>
        <p className="text-sm text-muted-foreground mt-4 leading-relaxed">
          The page you are looking for doesn’t exist. Head back home, or reach us directly for price, floor plans and availability.
        </p>
        <div className="flex flex-wrap justify-center gap-3 mt-8">
          <Link to="/" data-testid="notfound-home-link" className="rounded-full bg-palm text-ivory px-6 py-3 text-sm font-semibold hover:bg-palm-2 transition-colors">Back to Home</Link>
          <WhatsAppButton testid="notfound-whatsapp-btn" />
          <CallButton testid="notfound-call-btn" />
        </div>
      </div>
    </section>
  </>
);

export default NotFound;
